import type { FC, ReactNode } from 'react';

interface DashboardCardProps {
	title: string;
	titleIcon?: ReactNode;
	children: ReactNode;
	headerAction?: ReactNode;
	className?: string;
	fixedHeight?: boolean;
}

const DashboardCard: FC<DashboardCardProps> = ({
	title,
	titleIcon,
	children,
	headerAction,
	className,
	fixedHeight = false,
}) => (
	<div className={`bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col ${fixedHeight ? 'h-[280px]' : ''} ${className || ''}`}>
		<div className="flex justify-between items-center p-3 sm:p-4 border-b border-gray-200 flex-shrink-0">
			<h2 className="flex items-center gap-2 text-base font-semibold text-gray-800">
				{titleIcon}
				{title}
			</h2>
			{headerAction}
		</div>
		<div className={`p-3 sm:p-4 ${fixedHeight ? 'flex-1 overflow-y-auto' : ''}`}>
			{children}
		</div>
	</div>
);

export default DashboardCard;